import { ActiveGameScreen } from '@/screens/index'

export default function () {
  return <ActiveGameScreen />
}

// TODO: add screen options
// options={{
//   headerShown: false,
//   headerTitleAlign: 'center',
//   headerTitle: () => (
//     <View
//       style={{
//         width: '100%',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'center',
//         alignItems: 'center',
//         marginBottom: Platform.OS === 'ios' ? 8 : 0
//       }}
//     >
//       <Text
//         style={{
//           textAlign: 'center',
//           fontWeight: '800',
//           fontSize: moderateScale(20),
//           fontFamily: fontFamily.sfProDisplayHeavy,
//           color: '#fff',
//           textAlignVertical: 'center'
//         }}
//       >
//         Community Games
//       </Text>
//     </View>
//   ),
//   headerRight: () => <DrawerHamburgerButton />,
//   headerStyle: {
//     backgroundColor: 'rgb(5, 16,45)',
//     justifyContent: 'center',
//     alignItems: 'center',
//     display: 'flex',
//     height: insets.top + 35
//   }
// }}
